import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { DatabaseProvider } from './db/DatabaseProvider';
import { ToastProvider } from './components/common/ToastProvider';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import './styles/index.css';

import { useAuthStore } from './stores/auth.store';

// Initialize Auth before React mounts to prevent deadlock with DatabaseProvider
useAuthStore.getState().initialize();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <DatabaseProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </DatabaseProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
